import {
	AnalyticsProvider,
	CurrencyTypeProvider,
	DynamicConfigProvider,
	FCC,
	PortalStackProvider,
	RootContainer,
	ToastList,
	ToastProvider,
} from "@dgs/core";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { UnheadProvider, createHead } from "@unhead/react/client";
import { I18nextProvider } from "react-i18next";
import { PMAnalyticsProvider } from "./analytics/PMAnalyticsProvider";
import { PMBlockProvider } from "./blocks/PMBlockProvider";
import { HtmlTitle } from "./htmlTitle";
import i18n from "./i18n";
import { ProductTranslationsProvider } from "./i18n/ProductTranslationsProvider";
import { PMLocaleProvider } from "./locale/PMLocaleProvider";
import { PMAxiosConfig } from "./PMAxiosConfig";
import { PMAxiosErrorHandler } from "./PMAxiosErrorHandler";
import { PMThemeProvider } from "./PMThemeProvider";
import { RegionProvider } from "./region/RegionProvider";
import { Robots } from "./Robots";
import { IndexedDbProvider } from "./shared/storage/IndexedDbProvider";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: { staleTime: 100000, retry: false },
	},
});

const head = createHead();

export const AppProviders: FCC = ({ children }) => {
	return (
		<QueryClientProvider client={queryClient}>
			<DynamicConfigProvider>
				<PMAxiosConfig />
				<HtmlTitle />
				<Robots />
				<UnheadProvider head={head}>
					<AnalyticsProvider>
						<PMLocaleProvider>
							<CurrencyTypeProvider>
								<PMAnalyticsProvider>
									<PMThemeProvider>
										<ToastProvider>
											<I18nextProvider i18n={i18n}>
												<ProductTranslationsProvider />
												<PMBlockProvider>
													<IndexedDbProvider>
														<RootContainer>
															<RegionProvider>
																<PortalStackProvider>
																	<ToastList />
																	<PMAxiosErrorHandler />
																	{children}
																</PortalStackProvider>
															</RegionProvider>
														</RootContainer>
													</IndexedDbProvider>
												</PMBlockProvider>
											</I18nextProvider>
										</ToastProvider>
									</PMThemeProvider>
								</PMAnalyticsProvider>
							</CurrencyTypeProvider>
						</PMLocaleProvider>
					</AnalyticsProvider>
				</UnheadProvider>
			</DynamicConfigProvider>
		</QueryClientProvider>
	);
};
